<template>
	<div>
		<div class="colhead">
			<h2 class="header_h2">订单分组管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="分组名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>

		</el-header>

		<el-main>
			<el-table border ref="multipleTable" @row-click="SelectedChange" tooltip-effect="dark"
				:data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="GroupName" label="分组名称" width="260px"></el-table-column>
				<el-table-column prop="Sex" label="适用性别">
					<template slot-scope="scope">
						<div v-for="item in AdaptSex">
							<label v-if='scope.row.Sex==item.value'>{{item.key}}</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="Marry" label="婚否">
					<template slot-scope="scope">
						<div v-for="item1 in AdaptMarry">
							<label v-if='scope.row.Marry==item1.value'>{{item1.key}}</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="MinAge" label="年龄下限"></el-table-column>
				<el-table-column prop="MaxAge" label="年龄上限"></el-table-column>
				<el-table-column prop="GroupPrice" label="分组金额"></el-table-column>
				<el-table-column prop="Memo" label="备注"></el-table-column>
				<el-table-column label="操作" width="200px" fixed="right">
					<template slot-scope="scope">
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text"
							size="small">编辑</el-button>
						<el-button @click="handleDelete(scope.$index, scope.row)" icon="el-icon-circle-close"
							type="text" size="small">删除</el-button>

					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-sizes="[5, 10, 20, 40]" :page-size="pagesize"
							layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>

			<!-- 修改信息 -->
			<el-dialog title="修改信息" :visible.sync="bao1edit">
				<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
					<el-form-item label="分组名称">
						<el-input v-model="EditInfo.GroupName"></el-input>
					</el-form-item>
					<el-form-item label="适用性别">
						<el-select style=" width: 80px;  height:30px;" v-model="EditInfo.Sex">
							<el-option v-for="item in AdaptSex" :label="item.key" :value="item.value" placeholder="请选择">
								{{ item.key }}
							</el-option>
						</el-select>
						婚否：<el-select style=" width: 80px;  height:30px;" v-model="EditInfo.Marry">
							<el-option v-for="item in AdaptMarry" :label="item.key" :value="item.value"
								placeholder="请选择">
								{{ item.key }}
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="年龄下限">
						<el-input type='number' v-model="EditInfo.MinAge"></el-input>
					</el-form-item>
					<el-form-item label="年龄上限">
						<el-input type='number' v-model="EditInfo.MaxAge"></el-input>
					</el-form-item>
					<el-form-item label="分组金额">
						<el-input type='number' v-model="EditInfo.GroupPrice"></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="EditInfo.Memo"></el-input>
					</el-form-item>

					<!-- 按钮确定和取消 -->
					<el-form-item>
						<el-button type="primary" @click.native="bao1editSure">确定</el-button>
						<el-button @click.native="bao1edit = false">取消</el-button>
					</el-form-item>
				</el-form>

			</el-dialog>

			<!-- ----新增信息---- -->
			<el-dialog title="新增信息" :visible.sync="bao1newadd">
				<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
					<el-form-item label="分组名称">
						<el-input v-model="AddInfo.GroupName"></el-input>
					</el-form-item>
					<el-form-item label="适用性别">
						<el-select style=" width: 80px;  height:30px;" v-model="AddInfo.Sex">
							<el-option v-for="item in AdaptSex" :label="item.key" :value="item.value" placeholder="请选择">
								{{ item.key }}
							</el-option>
						</el-select>
						婚否：<el-select style=" width: 80px;  height:30px;" v-model="AddInfo.Marry">
							<el-option v-for="item in AdaptMarry" :label="item.key" :value="item.value"
								placeholder="请选择">
								{{ item.key }}
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="年龄下限">
						<el-input type='number' v-model="AddInfo.MinAge"></el-input>
					</el-form-item>
					<el-form-item label="年龄上限">
						<el-input type='number' v-model="AddInfo.MaxAge"></el-input>
					</el-form-item>
					<el-form-item label="分组金额">
						<el-input type='number' v-model="AddInfo.GroupPrice"></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="AddInfo.Memo"></el-input>
					</el-form-item>
					<!-- 按钮确定和取消 -->
					<el-form-item>
						<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
						<el-button @click.native="bao1newadd = false">取消</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>


		</el-main>
		<el-container>
			<RouterView></RouterView>
		</el-container>
	</div>
</template>



<script>
	import enums from '../../commontools/enums.js'
	import ordergroup from '../../apifunction/OrderGroup.js'
	//import '../../assets/css/mystyle.css'
	export default {
		created() {
			if (this.orderEnt != null)
				return;
			var ent = this.$route.query.ent;
			this.orderEnt = JSON.parse(ent);
		},
		data() {
			return {
				orderEnt: null,
				GroupList: [],
				AdaptSex: enums.AdaptSex,
				AdaptMarry: enums.AdaptMarry,
				currentPage: 1,
				pagesize: 5,
				bao1edit: false,
				bao1newadd: false,
				idx: null,
				//   通过姓名查询
				select_word: "",
				EditInfo: {
					OrderID: '',
					GroupID: '',
					GroupName: '',
					Sex: '3',
					MinAge: '0',
					MaxAge: '150',
					Marry: '3',
					CreatTime: '',
					Memo: '',
					GroupPrice: '0'
				},
				AddInfo: {
					OrderID: '',
					GroupID: '',
					GroupName: '',
					Sex: '3',
					MinAge: '0',
					MaxAge: '150',
					Marry: '3',
					CreatTime: '',
					Memo: '',
					GroupPrice: '0'
				}
			};
		},
		mounted() {
			this.GetOrderGroupList();
		},
		methods: {
			//   得到所有的数据---------------
			GetOrderGroupList() {

				ordergroup.GetOrderGroupData(this.orderEnt.OrderID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								this.GroupList = [];
							else
								this.GroupList = JSON.parse(ent.Data);

						} else
							this.$message.info(ent.Msg);
					})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;

				this.EditInfo = {
					OrderID: row.OrderID,
					GroupID: row.GroupID,
					GroupName: row.GroupName,
					Sex: row.Sex,
					MinAge: row.MinAge,
					MaxAge: row.MaxAge,
					Marry: row.Marry,
					CreatTime: row.CreatTime,
					Memo: row.Memo,
					GroupPrice: row.GroupPrice
				};
			},
			SelectedChange(row, col, event) {
				var data = {
					path: '/ordergroupitem',
					query: {
						ent: JSON.stringify(row)
					}
				};
				this.$router.push(data)
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				ordergroup.EditGroup(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.GroupList.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.OrderID = '';
				this.AddInfo.GroupID = '';
				this.AddInfo.GroupName = '';
				this.AddInfo.Sex = '3';
				this.AddInfo.MinAge = '0';
				this.AddInfo.MaxAge = '150';
				this.AddInfo.Marry = '3';
				this.AddInfo.GroupPrice = '0';
				this.AddInfo.Memo = '';
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if (this.AddInfo.GroupName == '') {
					this.$message.success("分组名称不能为空！");
					return;
				}
				let user = this.$myglobal.getUserInfo();
				this.AddInfo.OrderID = this.orderEnt.OrderID;
				this.AddInfo.GroupID = this.CommonFun.NewGuid();
				this.AddInfo.CreatTime = this.CommonFun.GetNowDateTime();
				ordergroup.AddGroup(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.GroupList.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			},
			handleDelete(index, row) {
				this.$confirm('确定要删掉此分组吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {
					ordergroup.DelGroup(row.OrderID, row.GroupID)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.GroupList.splice(index, 1)
								//this.bao1detele = false;
								this.$message.warning("删除成功");

							} else {
								this.$message.info(ent.Msg);
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
		},
		computed: {
			data() {
				return this.GroupList.filter(item => {

					if (item.GroupName.indexOf(this.select_word) > -1) {
						return item;
					}
				});
			}
		}
	};
</script>


<style scoped>

</style>
